import styled from 'styled-components/native';
import style, { hpx } from './../../styles/index';

export const Container = styled.View`
  padding: 20px;
`;

export const Text = styled.TextInput`
  margin-top: 10px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.small};
  height: 120px;
  text-align-vertical: top;
`;

export const Label = styled.Text`
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
  color: #333;
`;
